var de = Object.defineProperty;
var fe = (e, t, n) => t in e ? de(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var u = (e, t, n) => (fe(e, typeof t != "symbol" ? t + "" : t, n), n);
var P = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, j = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, K = new Array(4).fill(String.fromCodePoint(j[0])).join(""), B = "\0";
function Ee(e) {
  let t = JSON.stringify(e);
  return `${K}${Array.from(t).map((n) => {
    let r = n.charCodeAt(0);
    if (r > 255)
      throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${t} on character ${n} (${r})`);
    return Array.from(r.toString(4).padStart(4, "0")).map((i) => String.fromCodePoint(j[i])).join("");
  }).join("")}`;
}
function pe(e) {
  return !Number.isNaN(Number(e)) || /[a-z]/i.test(e) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(e) ? !1 : !!Date.parse(e);
}
function ge(e) {
  try {
    new URL(e, e.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function he(e, t, n = "auto") {
  return n === !0 || n === "auto" && (pe(e) || ge(e)) ? e : `${e}${Ee(t)}`;
}
var me = Object.fromEntries(Object.entries(j).map((e) => e.reverse())), F = Object.fromEntries(Object.entries(P).map((e) => e.reverse())), be = `${Object.values(P).map((e) => `\\u{${e.toString(16)}}`).join("")}`, C = new RegExp(`[${be}]{4,}`, "gu");
function ye(e) {
  let t = e.match(C);
  if (t)
    return Ie(t[0], !0)[0];
}
function Ie(e, t = !1) {
  let n = Array.from(e);
  if (n.length % 2 === 0) {
    if (n.length % 4 || !e.startsWith(K))
      return Te(n, t);
  } else
    throw new Error("Encoded data has invalid length");
  let r = [];
  for (let i = n.length * 0.25; i--; ) {
    let s = n.slice(i * 4, i * 4 + 4).map((o) => me[o.codePointAt(0)]).join("");
    r.unshift(String.fromCharCode(parseInt(s, 4)));
  }
  if (t) {
    r.shift();
    let i = r.indexOf(B);
    return i === -1 && (i = r.length), [JSON.parse(r.slice(0, i).join(""))];
  }
  return r.join("").split(B).filter(Boolean).map((i) => JSON.parse(i));
}
function Te(e, t) {
  var n;
  let r = [];
  for (let a = e.length * 0.5; a--; ) {
    let c = `${F[e[a * 2].codePointAt(0)]}${F[e[a * 2 + 1].codePointAt(0)]}`;
    r.unshift(String.fromCharCode(parseInt(c, 16)));
  }
  let i = [], s = [r.join("")], o = 10;
  for (; s.length; ) {
    let a = s.shift();
    try {
      if (i.push(JSON.parse(a)), t)
        return i;
    } catch (c) {
      if (!o--)
        throw c;
      let d = +((n = c.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : n[1]);
      if (!d)
        throw c;
      s.unshift(a.substring(0, d), a.substring(d));
    }
  }
  return i;
}
function Se(e) {
  var t;
  return { cleaned: e.replace(C, ""), encoded: ((t = e.match(C)) == null ? void 0 : t[0]) || "" };
}
function w(e, t) {
  return he(e, t);
}
function Z(e) {
  return ye(e);
}
function Xe(e) {
  return Se(e);
}
var ve = Object.prototype.hasOwnProperty, Ae = Object.prototype.toString, Oe = function(e, t, n) {
  if (Ae.call(t) !== "[object Function]")
    throw new TypeError("iterator must be a function");
  var r = e.length;
  if (r === +r)
    for (var i = 0; i < r; i++)
      t.call(n, e[i], i, e);
  else
    for (var s in e)
      ve.call(e, s) && t.call(n, e[s], s, e);
}, De = Oe, S = f;
function f(e, t, n) {
  if (arguments.length === 3)
    return f.set(e, t, n);
  if (arguments.length === 2)
    return f.get(e, t);
  var r = f.bind(f, e);
  for (var i in f)
    f.hasOwnProperty(i) && (r[i] = f[i].bind(r, e));
  return r;
}
f.get = function(e, t) {
  for (var n = Array.isArray(t) ? t : f.parse(t), r = 0; r < n.length; ++r) {
    var i = n[r];
    if (!(typeof e == "object" && i in e))
      throw new Error("Invalid reference token: " + i);
    e = e[i];
  }
  return e;
};
f.set = function(e, t, n) {
  var r = Array.isArray(t) ? t : f.parse(t), i = r[0];
  if (r.length === 0)
    throw Error("Can not set the root object");
  for (var s = 0; s < r.length - 1; ++s) {
    var o = r[s];
    typeof o != "string" && typeof o != "number" && (o = String(o)), !(o === "__proto__" || o === "constructor" || o === "prototype") && (o === "-" && Array.isArray(e) && (o = e.length), i = r[s + 1], o in e || (i.match(/^(\d+|-)$/) ? e[o] = [] : e[o] = {}), e = e[o]);
  }
  return i === "-" && Array.isArray(e) && (i = e.length), e[i] = n, this;
};
f.remove = function(e, t) {
  var n = Array.isArray(t) ? t : f.parse(t), r = n[n.length - 1];
  if (r === void 0)
    throw new Error('Invalid JSON pointer for remove: "' + t + '"');
  var i = f.get(e, n.slice(0, -1));
  if (Array.isArray(i)) {
    var s = +r;
    if (r === "" && isNaN(s))
      throw new Error('Invalid array index: "' + r + '"');
    Array.prototype.splice.call(i, s, 1);
  } else
    delete i[r];
};
f.dict = function(e, t) {
  var n = {};
  return f.walk(e, function(r, i) {
    n[i] = r;
  }, t), n;
};
f.walk = function(e, t, n) {
  var r = [];
  n = n || function(i) {
    var s = Object.prototype.toString.call(i);
    return s === "[object Object]" || s === "[object Array]";
  }, function i(s) {
    De(s, function(o, a) {
      r.push(String(a)), n(o) ? i(o) : t(o, f.compile(r)), r.pop();
    });
  }(e);
};
f.has = function(e, t) {
  try {
    f.get(e, t);
  } catch {
    return !1;
  }
  return !0;
};
f.escape = function(e) {
  return e.toString().replace(/~/g, "~0").replace(/\//g, "~1");
};
f.unescape = function(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
};
f.parse = function(e) {
  if (e === "")
    return [];
  if (e.charAt(0) !== "/")
    throw new Error("Invalid JSON pointer: " + e);
  return e.substring(1).split(/\//).map(f.unescape);
};
f.compile = function(e) {
  return e.length === 0 ? "" : "/" + e.map(f.escape).join("/");
};
const Ne = ({
  pointer: e,
  mappings: t,
  data: n,
  hiddenStrings: r
}) => {
  const i = t[e];
  delete t[e];
  const s = q(n, e);
  for (const o of s) {
    t[o] = i;
    const a = S.get(n, o), c = w(a, r);
    S.set(n, o, c);
  }
}, q = (e, t = "") => {
  const n = [], r = S.get(e, t);
  if (r.content)
    for (let i = 0; i < r.content.length; i++)
      r.content[i].nodeType === "text" ? n.push(`${t}/content/${i}/value`) : n.push(...q(e, `${t}/content/${i}`));
  return n;
}, M = ({
  entityId: e,
  entityType: t,
  space: n,
  environment: r,
  field: i,
  locale: s,
  editorInterface: o,
  fieldType: a,
  targetOrigin: c
}) => ({
  origin: "contentful.com",
  href: `${`${c || "https://app.contentful.com"}/spaces/${n}/environments/${r}`}/${t === "Entry" ? "entries" : "assets"}/${e}/?focusedField=${i}&focusedLocale=${s}`,
  contentful: {
    space: n,
    environment: r,
    field: i,
    locale: s,
    entity: e,
    entityType: t,
    editorInterface: o,
    fieldType: a
  }
}), W = (e) => ["builtin", "sidebar-builtin", "editor-builtin"].includes(e), Q = (e) => Re.includes(e);
function X(e) {
  if (typeof structuredClone == "function")
    return structuredClone(e);
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return console.warn("Failed to clone data:", e, t), e;
  }
}
const Re = [
  "singleLine",
  "tagEditor",
  "listInput",
  "checkbox",
  "richTextEditor",
  "multipleLine",
  "markdown"
];
function U(e, t, n, r, i, s, o) {
  const a = o ? t[o] : t;
  switch (e) {
    case "Symbol": {
      const c = w(a, n);
      S.set(r, i, c);
      break;
    }
    case "RichText": {
      Ne({
        pointer: "",
        mappings: s,
        data: a,
        hiddenStrings: n
      });
      break;
    }
    case "Array": {
      const c = a.map((d) => typeof d == "string" ? w(d, n) : d);
      S.set(r, i, c);
      break;
    }
  }
}
const et = (e, t) => {
  if (!e || !e.extensions || !e.extensions.contentSourceMaps)
    return console.error(
      "GraphQL response does not contain Content Source Maps information.",
      e
    ), e;
  const n = X(
    e
  ), {
    spaces: r,
    environments: i,
    editorInterfaces: s,
    fields: o,
    locales: a,
    entries: c,
    assets: d,
    mappings: g,
    fieldTypes: E
  } = n.extensions.contentSourceMaps, p = n.data;
  for (const b in g) {
    const { source: h } = g[b], v = "entry" in h ? c[h.entry] : d[h.asset], D = "entry" in h ? "Entry" : "Asset";
    if (!v)
      return n;
    const A = r[v.space], R = i[v.environment], ae = v.id, ce = o[h.field], le = a[h.locale], L = s[h.editorInterface], G = E[h.fieldType];
    if (!(W(L.widgetNamespace) && !Q(L.widgetId)))
      if (S.has(p, b)) {
        const x = S.get(p, b);
        if (x !== null) {
          const ue = M({
            entityId: ae,
            entityType: D,
            space: A,
            environment: R,
            field: ce,
            locale: le,
            editorInterface: L,
            fieldType: G,
            targetOrigin: t
          });
          U(G, x, ue, p, b, g);
        }
      } else
        console.error(`Pointer ${b} not found in GraphQL data or href could not be generated.`);
  }
  return n;
}, N = (e, t, n, r) => {
  if (!e.fields)
    return;
  const { contentSourceMaps: i } = e.sys;
  if (!i) {
    console.error("Content source maps data is missing");
    return;
  }
  const { mappings: s } = i;
  for (const o in s) {
    const { source: a } = s[o], c = e.sys.space.sys.id, d = e.sys.environment.sys.id, g = e.sys.id, E = e.sys.type, p = t[a.fieldType], b = n[a.editorInterface];
    if (!(W(b.widgetNamespace) && !Q(b.widgetId)))
      if (S.has(e, o)) {
        const h = S.get(e, o);
        if (h === null)
          return;
        const v = o.split("/").pop();
        if (!v) {
          console.error("Field name could not be extracted from the pointer", o);
          return;
        }
        const D = e.sys.locale;
        if (D) {
          const A = M({
            entityId: g,
            entityType: E,
            space: c,
            environment: d,
            field: v,
            locale: D,
            editorInterface: b,
            fieldType: p,
            targetOrigin: r
          });
          U(p, h, A, e, o, s);
        } else
          Object.keys(h).forEach((A) => {
            const R = M({
              entityId: g,
              entityType: E,
              space: c,
              environment: d,
              field: v,
              locale: A,
              editorInterface: b,
              fieldType: p,
              targetOrigin: r
            });
            U(
              p,
              h,
              R,
              e,
              `${o}/${A}`,
              s,
              A
            );
          });
      } else
        console.error("Pointer not found in the target", o, e);
  }
}, tt = (e, t) => {
  const n = X(
    e
  );
  if (n.sys.type === "Array") {
    const r = n;
    if (!r.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), r;
    const {
      contentSourceMapsLookup: { fieldTypes: i, editorInterfaces: s }
    } = r.sys, { items: o, includes: a } = r;
    o.forEach((c) => N(c, i, s, t)), a && a.Entry && a.Entry.forEach(
      (c) => N(c, i, s, t)
    ), a && a.Asset && a.Asset.forEach(
      (c) => N(c, i, s, t)
    );
  } else {
    const r = n;
    if (!r.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), r;
    N(
      r,
      r.sys.contentSourceMapsLookup.fieldTypes,
      r.sys.contentSourceMapsLookup.editorInterfaces,
      t
    );
  }
  return n;
}, ee = "3.3.7";
let te = !1;
function k(e) {
  te = e;
}
const _ = (e) => (...t) => {
  te && console[e](...t);
}, O = {
  error: _("error"),
  warn: _("warn"),
  log: _("log")
};
function Le(e, t = 500) {
  let n = window.location.href;
  const i = setInterval(() => {
    const s = window.location.href;
    s !== n && (n = s, e(s));
  }, t);
  return () => clearInterval(i);
}
const _e = "live-preview-editor", Ce = "live-preview-sdk";
function y(e, t, n) {
  const r = {
    ...t,
    method: e,
    source: Ce,
    location: window.location.href,
    version: ee
  };
  O.log("Send message", r), n.forEach((i) => {
    var s;
    (s = window.top) == null || s.postMessage(r, i);
  });
}
function nt(e, t = 100) {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => {
      e.apply(this, r);
    }, t);
  };
}
function we() {
  var e;
  try {
    return ((e = window.top) == null ? void 0 : e.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function Me() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function Ue(e) {
  return typeof e.data != "object" || !e.data ? !1 : "source" in e.data && e.data.source === _e;
}
var l = /* @__PURE__ */ ((e) => (e.FIELD_ID = "data-contentful-field-id", e.ENTRY_ID = "data-contentful-entry-id", e.ASSET_ID = "data-contentful-asset-id", e.LOCALE = "data-contentful-locale", e.SPACE = "data-contentful-space", e.ENVIRONMENT = "data-contentful-environment", e))(l || {}), T = /* @__PURE__ */ ((e) => (e.MOUSE_MOVE = "MOUSE_MOVE", e.SCROLL_START = "SCROLL_START", e.SCROLL_END = "SCROLL_END", e.RESIZE_START = "RESIZE_START", e.RESIZE_END = "RESIZE_END", e.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", e.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", e))(T || {}), ne = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, re = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 };
new Array(4).fill(String.fromCodePoint(re[0])).join("");
Object.fromEntries(Object.entries(re).map((e) => e.reverse()));
Object.fromEntries(Object.entries(ne).map((e) => e.reverse()));
var $e = `${Object.values(ne).map((e) => `\\u{${e.toString(16)}}`).join("")}`, je = new RegExp(`[${$e}]{4,}`, "gu");
const Ge = (e) => {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = e;
  return !(!t.hasAttribute(l.FIELD_ID) || !t.hasAttribute(l.ENTRY_ID) && !t.hasAttribute(l.ASSET_ID));
};
function V(e, t) {
  if (!Ge(e))
    return null;
  const n = {
    fieldId: e.getAttribute(l.FIELD_ID),
    locale: e.getAttribute(l.LOCALE) ?? t.locale,
    environment: e.getAttribute(l.ENVIRONMENT) ?? t.environment,
    space: e.getAttribute(l.SPACE) ?? t.space
  }, r = e.getAttribute(l.ENTRY_ID);
  if (r)
    return { ...n, entryId: r };
  const i = e.getAttribute(l.ASSET_ID);
  return i ? { ...n, assetId: i } : null;
}
function ie(e, t) {
  return e.href === t.href;
}
function xe(e, t) {
  return !(!ie(e.sourceMap, t.sourceMap) || e.element !== t.element);
}
function se(e, t, n = 3) {
  if (n === 0)
    return null;
  const r = e.parentElement;
  if (r) {
    const i = {
      sameInformation: 0,
      tagged: 0,
      all: 0
    };
    let s = e.nextElementSibling;
    for (; s; ) {
      const a = Z(s.textContent || "");
      a && (i.tagged += 1, a.href === t.href && (i.sameInformation = 1)), i.all += 1, s = s.nextElementSibling;
    }
    const o = se(r, t, n - 1);
    if (o && o.counters.sameInformation >= 1)
      return o;
    if (i.sameInformation >= 1)
      return { element: r, counters: i };
  }
  return null;
}
function Be(e) {
  let t = [];
  return typeof e.matches == "function" && e.matches("*") && (t = [e]), [
    ...t,
    ...Array.from(e.querySelectorAll("*:not(script,style,meta,title)"))
  ].map((n) => ({ node: n, text: Fe(n) })).filter(({ text: n }) => !!(n && n.match(je)));
}
function Fe(e) {
  return e.matches("input[type=submit], input[type=button], input[type=reset]") ? e.value : e.matches("img, video") ? e.alt : Array.from(e.childNodes).filter((t) => t.nodeType === Node.TEXT_NODE && !!t.textContent).map((t) => t.textContent).join("");
}
function ke(e, t) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
  return !1;
}
function $(e = window.document, t) {
  const r = [...t ? [] : e.querySelectorAll(
    `[${l.ASSET_ID}][${l.FIELD_ID}], [${l.ENTRY_ID}][${l.FIELD_ID}]`
  )], i = [], s = Be("body" in e ? e.body : e);
  for (const { node: a, text: c } of s) {
    const d = Z(c);
    if (!d || !d.origin.includes("contentful.com") || ke(a, r) || i.some(
      (E) => E.element.contains(a) && ie(E.sourceMap, d)
    ))
      continue;
    if (a.matches("img")) {
      const E = a.closest("figure") || a.closest("picture") || a;
      i.push({ element: E, sourceMap: d });
      continue;
    }
    const g = se(a, d);
    g ? i.push({ element: g.element, sourceMap: d }) : i.push({ element: a, sourceMap: d });
  }
  const o = i.filter(
    (a, c) => i.findIndex((d) => xe(a, d)) === c
  );
  for (const { element: a, sourceMap: c } of o)
    c.contentful.entityType === "Asset" ? a.setAttribute(l.ASSET_ID, c.contentful.entity) : a.setAttribute(l.ENTRY_ID, c.contentful.entity), a.setAttribute(l.FIELD_ID, c.contentful.field), a.setAttribute(l.LOCALE, c.contentful.locale), a.setAttribute(l.SPACE, c.contentful.space), a.setAttribute(l.ENVIRONMENT, c.contentful.environment), r.push(a);
  return r;
}
function oe() {
  return [
    ...new Set(
      $().map((e) => e.getAttribute(l.ENTRY_ID)).filter(Boolean)
    )
  ];
}
class Ve {
  constructor(t) {
    u(this, "isScrolling", !1);
    u(this, "scrollTimeout");
    u(this, "isResizing", !1);
    u(this, "resizeTimeout");
    u(this, "hoveredElement");
    u(this, "taggedElements", []);
    u(this, "taggedElementMutationObserver");
    // Handles incoming messages from Contentful
    u(this, "receiveMessage", (t) => {
      if (t.method === T.INSPECTOR_MODE_CHANGED) {
        const { isInspectorActive: n } = t;
        n && this.sendAllElements();
      }
    });
    /** Checks if the hovered element is an tagged entry and then sends it to the editor */
    u(this, "addHoverListener", () => {
      const t = (n) => {
        const r = n.composedPath();
        for (const i of r) {
          const s = i;
          if (s.nodeName === "BODY")
            break;
          if (typeof (s == null ? void 0 : s.getAttribute) == "function" && this.handleTaggedElement(s))
            return;
        }
        this.hoveredElement && (this.hoveredElement = void 0, y(
          T.MOUSE_MOVE,
          { element: null },
          this.options.targetOrigin
        ));
      };
      return window.addEventListener("mouseover", t), () => window.removeEventListener("mouseover", t);
    });
    /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
    u(this, "addScrollListener", () => {
      const { targetOrigin: t } = this.options, n = () => {
        this.isScrolling || (this.isScrolling = !0, y(T.SCROLL_START, {}, t)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
          this.isScrolling = !1, y(T.SCROLL_END, {}, t), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
        }, 150);
      };
      return window.addEventListener("scroll", n), () => window.removeEventListener("scroll", n);
    });
    /** Detects DOM changes and sends the tagged elements to the editor */
    u(this, "addMutationListener", () => {
      const t = new MutationObserver(() => {
        var r;
        const n = $();
        ((r = this.taggedElements) == null ? void 0 : r.length) !== n.length && this.sendAllElements();
      });
      return t.observe(document.body, {
        attributes: !0,
        attributeFilter: [
          l.ENTRY_ID,
          l.FIELD_ID,
          l.LOCALE,
          l.SPACE,
          l.ENVIRONMENT
        ],
        childList: !0,
        subtree: !0
      }), () => t.disconnect();
    });
    /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
    u(this, "addResizeListener", () => {
      const { targetOrigin: t } = this.options, n = new ResizeObserver(() => {
        this.isResizing || (this.isResizing = !0, y(T.RESIZE_START, {}, t)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
          this.isResizing = !1, y(T.RESIZE_END, {}, t), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
        }, 150);
      });
      return n.observe(document.body), () => n.disconnect();
    });
    /**
     * Validates if the element has the inspector mode attributes
     * and sends it then to the editor
     */
    u(this, "handleTaggedElement", (t) => {
      const { targetOrigin: n, locale: r, space: i, environment: s } = this.options, o = V(t, { locale: r, space: i, environment: s });
      return o ? (this.hoveredElement = t, y(
        T.MOUSE_MOVE,
        {
          element: {
            attributes: o,
            coordinates: t.getBoundingClientRect()
          }
        },
        n
      ), !0) : !1;
    });
    /**
     * Finds all elements that have all inspector mode attributes
     * and sends them to the editor
     */
    u(this, "sendAllElements", () => {
      const { targetOrigin: t, locale: n, space: r, environment: i } = this.options, s = $();
      this.taggedElements = s, this.taggedElementMutationObserver && this.taggedElementMutationObserver.disconnect();
      const o = () => {
        y(
          T.TAGGED_ELEMENTS,
          {
            elements: s.map((a) => ({
              attributes: V(a, { locale: n, space: r, environment: i }),
              coordinates: a.getBoundingClientRect()
            }))
          },
          t
        );
      };
      this.taggedElementMutationObserver = new MutationObserver(o), this.taggedElements.forEach((a) => {
        var c;
        (c = this.taggedElementMutationObserver) == null || c.observe(a, {
          attributes: !0,
          attributeFilter: [
            l.ENTRY_ID,
            l.FIELD_ID,
            l.LOCALE,
            l.SPACE,
            l.ENVIRONMENT
          ],
          childList: !0,
          subtree: !0,
          characterData: !0
        });
      }), o();
    });
    this.options = t, this.addHoverListener(), this.addScrollListener(), this.addMutationListener(), this.addResizeListener();
  }
}
const { parse: rt, stringify: ze } = JSON, Ye = String, He = "string", z = "object", Je = (e, t) => t, Y = (e, t, n) => {
  const r = Ye(t.push(n) - 1);
  return e.set(n, r), r;
}, Pe = (e, t, n) => {
  const r = t && typeof t === z ? (g, E) => g === "" || -1 < t.indexOf(g) ? E : void 0 : t || Je, i = /* @__PURE__ */ new Map(), s = [], o = [];
  let a = +Y(i, s, r.call({ "": e }, "", e)), c = !a;
  for (; a < s.length; )
    c = !0, o[a] = ze(s[a++], d, n);
  return "[" + o.join(",") + "]";
  function d(g, E) {
    if (c)
      return c = !c, E;
    const p = r.call(this, g, E);
    switch (typeof p) {
      case z:
        if (p === null)
          return p;
      case He:
        return i.get(p) || Y(i, s, p);
    }
    return p;
  }
};
var I = /* @__PURE__ */ ((e) => (e.CONNECTED = "CONNECTED", e.DISCONNECTED = "DISCONNECTED", e.ERROR = "ERROR", e.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", e.URL_CHANGED = "URL_CHANGED", e.SUBSCRIBED = "SUBSCRIBED", e.UNSUBSCRIBED = "UNSUBSCRIBED", e.ENTRY_UPDATED = "ENTRY_UPDATED", e.ENTRY_SAVED = "ENTRY_SAVED", e.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", e))(I || {});
function Ke(e, t) {
  y(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...e
    },
    t
  );
}
function Ze(e, t) {
  y(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...e
    },
    t
  );
}
class qe {
  constructor({ locale: t, targetOrigin: n }) {
    u(this, "subscriptions", /* @__PURE__ */ new Map());
    u(this, "defaultLocale");
    u(this, "sendMessage");
    this.defaultLocale = t, this.sendMessage = (r, i) => y(r, i, n);
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(t) {
    if (t.method === I.ENTRY_UPDATED) {
      const { data: n, subscriptionId: r } = t, i = this.subscriptions.get(r);
      i ? (i.callback(n), i.data = n, this.subscriptions.set(r, i)) : O.error("Received an update for an unknown subscription", {
        subscriptionId: r,
        data: n,
        subscriptions: this.subscriptions
      });
    }
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(t) {
    const n = Me(), r = t.locale ?? this.defaultLocale;
    this.subscriptions.set(n, {
      ...t
    });
    const i = {
      locale: r,
      event: "edit",
      id: n,
      config: Pe(t)
    };
    return this.sendMessage(I.SUBSCRIBED, i), () => {
      this.sendMessage(I.UNSUBSCRIBED, i), this.subscriptions.delete(n);
    };
  }
}
class We {
  constructor({ locale: t }) {
    u(this, "locale");
    u(this, "subscription");
    this.locale = t;
  }
  subscribe(t) {
    return this.subscription && O.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = t, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(t) {
    if (t.method === I.ENTRY_SAVED && this.subscription) {
      const { entity: n } = t;
      oe().includes(n.sys.id) && this.subscription(n);
    }
  }
}
const it = ee, H = [
  "https://app.contentful.com",
  "https://app.eu.contentful.com",
  "http://localhost:3001"
  // for local debugging for Contentful engineers
], m = class m {
  // Static method to initialize the LivePreview SDK
  static init(t) {
    var d;
    if (typeof t != "object" || !(t != null && t.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: n,
      enableInspectorMode: r,
      enableLiveUpdates: i,
      locale: s,
      environment: o,
      space: a,
      targetOrigin: c
    } = t;
    if (typeof window < "u") {
      if (!we())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (n && k(n), typeof r == "boolean" && (this.inspectorModeEnabled = r), typeof i == "boolean" && (this.liveUpdatesEnabled = i), this.locale = s, this.space = a, this.environment = o, this.initTargetOrigin(c), this.initialized)
        return O.log("You have already initialized the Live Preview SDK."), Promise.resolve(m.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new Ve({
        locale: s,
        space: a,
        environment: o,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: (d = t.experimental) == null ? void 0 : d.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new qe({ locale: s, targetOrigin: this.targetOrigin }), this.saveEvent = new We({ locale: s })), window.addEventListener("message", (E) => {
        var p, b, h;
        if (Ue(E)) {
          if (O.log("Received message", E.data), E.data.method === I.DEBUG_MODE_ENABLED) {
            k(!0);
            return;
          }
          this.inspectorModeEnabled && ((p = this.inspectorMode) == null || p.receiveMessage(E.data)), this.liveUpdatesEnabled && ((b = this.liveUpdates) == null || b.receiveMessage(E.data), (h = this.saveEvent) == null || h.receiveMessage(E.data));
        }
      }), Le(() => {
        y(
          I.URL_CHANGED,
          {
            action: I.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${l.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const g = document.querySelectorAll(
        `[${l.ENTRY_ID}]`
      ).length;
      return y(
        I.CONNECTED,
        {
          action: I.CONNECTED,
          connected: !0,
          tags: g,
          taggedElementCount: g,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(m.inspectorMode);
    }
  }
  static initTargetOrigin(t) {
    if (t)
      this.targetOrigin = Array.isArray(t) ? t : [t];
    else {
      const n = window.location.ancestorOrigins, r = n ? H.find((i) => n.contains(i)) : (
        //less consistent workaround for Firefox, where ancestorOrigins is not supported
        H.find((i) => document.referrer.includes(i))
      );
      if (!r)
        throw new Error(
          "The current origin is not supported. Please provide a targetOrigin in the live preview configuration."
        );
      this.targetOrigin = [r];
    }
  }
  static subscribe(t, n) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const r = typeof t == "string" ? t : "edit", i = typeof t == "object" ? t : n;
    if (r === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(i.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(i);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(t) {
    const { fieldId: n, locale: r, environment: i, space: s } = t;
    if (!this.inspectorModeEnabled)
      return null;
    if (n) {
      const o = {
        ...r ? { [l.LOCALE]: r } : {},
        ...i ? { [l.ENVIRONMENT]: i } : {},
        ...s ? { [l.SPACE]: s } : {},
        [l.FIELD_ID]: n
      };
      if (r && (o[l.LOCALE] = r), t.assetId !== void 0)
        return {
          ...o,
          [l.ASSET_ID]: t.assetId
        };
      if (t.entryId !== void 0)
        return {
          ...o,
          [l.ENTRY_ID]: t.entryId
        };
    }
    return O.warn("Missing property for inspector mode", { ...t }), null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  static openEntryInEditor(t) {
    const n = {
      locale: this.locale,
      environment: this.environment,
      space: this.space
    };
    if (t.assetId !== void 0 && t.fieldId) {
      Ze(
        {
          ...n,
          ...t
        },
        this.targetOrigin
      );
      return;
    }
    if (t.entryId !== void 0 && t.fieldId) {
      Ke(
        {
          ...n,
          ...t
        },
        this.targetOrigin
      );
      return;
    }
    O.error("Please provide field id and entry id to openEntryInEditor.");
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return oe();
  }
};
u(m, "initialized", !1), u(m, "inspectorMode", null), u(m, "liveUpdates", null), u(m, "saveEvent", null), u(m, "inspectorModeEnabled", !0), u(m, "liveUpdatesEnabled", !0), u(m, "locale"), u(m, "space"), u(m, "environment"), u(m, "sendMessage"), u(m, "targetOrigin");
let J = m;
export {
  J as C,
  T as I,
  _e as L,
  it as V,
  tt as a,
  Ce as b,
  Xe as c,
  nt as d,
  I as e,
  Ze as f,
  et as i,
  Ke as o
};
//# sourceMappingURL=index-qWGrnG3Q.js.map
